import { Button } from "@/shared/ui/button.tsx"
import { CircleCheck } from "lucide-react"
import { ButtonHTMLAttributes } from "react"

type Props = {
  platform: { name: string, url: string },
  hasOtherPlatforms: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>

const PublishButton = ({ platform, hasOtherPlatforms, ...props }: Props) => {

  return <Button
    {...props}
    type="button"
    variant="outline"
    className="w-full sm:w-1/3 text-sm flex items-center gap-1 lg:text-base rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600">
    <CircleCheck />
    Publish on
    {hasOtherPlatforms ? " selected platforms" :
      <>
        <img src={platform.url} className="size-4" />
        <span className="hidden lg:block">
          {platform.name}
        </span>
      </>
    }
  </Button>
}

export default PublishButton;
